import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

/**
 * @description Get the key for the coachmark in localStorage
 */
export function getCoachmarkSeenCountStorageKey(id: string): string {
  const baseKey = `${LOCAL_STORAGE_KEYS.COACHMARK_SEEN_PREFIX}${id}`;
  return baseKey;
}

/**
 * @description Get the count of how many times a coachmark has been seen
 */
export function getCoachmarkSeenCount(id: string): number {
  const key = getCoachmarkSeenCountStorageKey(id);
  return parseInt(localStorage.getItem(key) || '0', 10);
}

/**
 * @description Increment the count of how many times a coachmark has been seen
 */
export function incrementCoachmarkSeenCount(id: string): void {
  const key = getCoachmarkSeenCountStorageKey(id);
  const count = getCoachmarkSeenCount(id);
  localStorage.setItem(key, (count + 1).toString());
}

/**
 * @description Determine if a coachmark should be shown based on the number of times it has been seen
 */
export function shouldShowCoachmark(id: string, maxInstances: number): boolean {
  return getCoachmarkSeenCount(id) <= maxInstances;
}
